import { QueryObserverOptions, useQuery } from '@tanstack/react-query';

import { UnknownObject } from '@tulp';

import { ChatQueryStore } from '../query-store';

export function useGetChatToken(options?: QueryObserverOptions<string>) {
  return useQuery({ ...ChatQueryStore.token, ...((options || {}) as UnknownObject) });
}
